import { v4 as uuidv4 } from 'uuid';
import store from '../../redux/store'

const basicCustomer={fullName:'',age:'',birthdate:"",email:null,phone:'',geo:JSON.stringify({})}
const SortList=(list)=>{
    return list.sort(function(a, b){
        if(a.fullName < b.fullName) { return -1; }
        if(a.fullName > b.fullName) { return 1; }
        return 0;
    })
}

export const initialState = {customersList: [],scanerReady:true,customer:{customerId:uuidv4()}};

export default function reducer(state=initialState, action) {
    switch (action.type) {
      //CUSTOMER
      case 'UPDATE_CUSTOMER':
        const customersList=[...state.customersList.filter(x=>x.customerId!=action.payload.customerId)];
        let customer=action.payload;
        return {...state,customer:{...basicCustomer,...customer},customersList:SortList([...customersList,{...action.payload}].sort((a,b)=>a.fullName))};
      case 'SELECT_CUSTOMER':
        return {...state,customer:state.customersList.find(x=>x.customerId==action.payload)};
      case 'REMOVE_CUSTOMER':
        return {...state,customersList:SortList(state.customersList.filter(x=>x.customerId!=action.payload))};
      case 'INIT_CUSTOMERS_LIST':
        return {...initialState,customersList:SortList(action.payload)};
      case 'ADD_CUSTOMER':
        const customerId = uuidv4();   

        return {...state,customer:{
            customerId,
           ...basicCustomer
        },
        
        customersList:[...state.customersList]
    };
    //SCANER
    case 'SET_SCANER':
      return {...state,scanerReady:action.payload};
      default:
        return state;
    }
  }